import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Divider from 'components/Luxkit/Divider'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

const USPs: Array<{ title: string, description: string}> = [
  {
    title: 'Instant VIP benefits',
    description: 'The more you travel, the more you unlock, from chauffeur airport transfers, room upgrades to lounge passes and more.',
  },
  {
    title: 'Earn & save',
    description: 'Get rewarded every time you book. Earn points and use them to pay less on future escapes.',
  },
  {
    title: 'It\'s free!',
    description: 'You can enjoy exclusive perks, points, and VIP benefits without paying to join.',
  },
]

const USPSection = styled.div`
  display: grid;
  gap: ${rem(16)};
  padding: ${rem(24)};
  
  ${mediaQueryUp.tablet} {
    grid-template-columns: 1fr min-content 1fr min-content 1fr;
    gap: ${rem(40)};
    padding: ${rem(48)} 0;
  }
`

function LoyaltyLandingPageUSPSection() {
  return <Pane paletteType="inverse">
    <LayoutContainer>
      <USPSection>
        {USPs.map((usp, index) => <React.Fragment key={usp.title}>
          {index !== 0 && <Divider kind="primary" direction="horizontal" tabletDirection="vertical" />}
          <VerticalSpacer gap={4}>
            <Heading variant="heading5" align="center">{usp.title}</Heading>
            <BodyText variant="medium" align="center">{usp.description}</BodyText>
          </VerticalSpacer>
        </React.Fragment>)}
      </USPSection>
    </LayoutContainer>
  </Pane>
}

export default LoyaltyLandingPageUSPSection
